const TITLE_FONTS = [
  "TahomaB24",
  "TahomaB36",
  "TahomaB48",
  "CourierNewB64",
  "Garamond64",
  "SteelfishB64",
  "SteelfishB128",
  "AudreysHandB48",
  "AudreysHandI48"
];

export default TITLE_FONTS;